import { React, useState, useEffect } from "react";
import {
  Paper,
  Typography,
  Box,
  Icon,
  Button,
  Modal,
  useTheme,
  TextField,
  Switch,
  Backdrop,
  CircularProgress,
  Snackbar,
  Alert,
  MenuItem,
  Table,
  TableCell,
  TableContainer,
  TableBody,
  TableHead,
  TableRow,
} from "@mui/material";
import { Formik, Form } from "formik";
import { useNavigate } from "react-router-dom";
import PhoneIcon from "../../Svg/PhoneIcon";
// import DatePicker from "react-datepicker";
// import { CustomDateInput } from "../../common/components/index";

// Mui X Date
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

// user Imports

import { makeStyles } from "@mui/styles";
import FormModal from "../FormModal";

import { MainRoutes } from "../../Services/Routes/App";
import { ApiUrls } from "../../Services/Routes/API";
import { headersGet, headersPost } from "../../Services/API";
import { createWalletValidation } from "../../Services/validation/CreateWallet";
// import { StorageKeys } from "../../Services/Storage";
import {
  ModalValidationBqankTransfer,
  ModalValidationPayAttitude,
  ModalValidationViaCreditCard,
  ModalValidationUSSD,
} from "../../Services/validation/modalValidation";
import {
  LimospayTextIcon,
  MasterCard,
  FundWalletIcon,
  TransactionIcon,
  WalletCreationIcon,
  FreezeWalletIcon,
  RemoveWalletIcon,
  BankIcon,
  BackIcon,
  ArrowIcon,
  // PayAttitudeIcon,
  Pay,
  CopyIcon,
  SuccessIcon,
  ModalSpinner,
  ToggleBlueOff,
  ToggleBlueOn,
} from "../../Svg";
import CallIcon from "../../Svg/CallIcon";
import WalletListIcon from "../../Svg/WalletListIcon";
import DelModal from "../../pages/Admin/DelModal";
import LoadCard from "../LoadCard";
import SuccessCard from "../SuccessCard";

// Modal Imports

import UssdModal from "./UssdModal/index";
import ViaBankAccountModal from "./ViaBankAccountModal";

// styling

const useStyles = makeStyles({
  flexSetting: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
  list: {
    overflowY: "auto",
    margin: 0,
    padding: 0,
    listStyle: "none",
    height: "100%",
    "&::-webkit-scrollbar": {
      width: "0em",
    },
    "&::-webkit-scrollbar-track": {
      boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
      webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(0,0,0,0)",
      outline: "1px solid white",
    },
  },
});

// const Wall = true;

// Initial Values Create Wallet

const initialValues = {
  name: "",
  category: "",
  email: "",
  phone_Number: "",
  bvn: "",
  is_default: false,
};

// Initial Values for Fund Wallet Via Credit Card
const initialValues1 = {
  funding_type: "credit_card",
  amount: "",
  main_type: "add_funds",
  action: "issue",
  card_number: "",
  name_on_card: "",
  expiration: "",
  cvv: "",
  password: "",
  wallet_id: "",
};

const CustomListItem = ({ defaultWallet = {}, cards = [] }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const classes = useStyles();

  let resourcevariable;

  // states

  const [banks, setBanks] = useState([]);
  const [expirationDate, setExpirationDate] = useState("");
  const [freezeModal, setFreezeModal] = useState(false);
  const [api, setApi] = useState(false);
  const [openFreezeModal, setOpenFreezeModal] = useState(false);
  const [product, setProduct] = useState([]);

  const headings = ["Name", "Balance", "Status"];

  const Wallettasks = [
    {
      icon: <WalletCreationIcon />,
      text: "Create Wallet",
      subtitle: "",
      handler: () => {
        setModalOpen(true);
      },
    },
    {
      icon: <FundWalletIcon />,
      text: "Fund Wallet",
      subtitle: "",
      handler: (data) => {
        setMainTypeForPage1("add_fund");
        setPageNumber(2);
      },
    },
    {
      icon: <TransactionIcon />,
      text: "Transactions",
      subtitle: "",
      handler: () => {
        alert("Transactions clicked");
      },
    },
    {
      icon: <FreezeWalletIcon />,
      text: "Freeze Wallet",
      subtitle: "",
      handler: () => {
        setFreezeModal(true);
      },
    },
    {
      icon: <RemoveWalletIcon />,
      text: "Remove Wallet",
      subtitle: "",
      handler: () => {
        alert("Remove Wallet clicked");
      },
    },
  ];

  const PAGE_2_LIST = [
    {
      icon: <MasterCard />,
      text: "Fund Wallet Via Credit Card",
      subtitle: "Mastercard , Verve , Visa",
      handler: () => {
        setFundWalletModal(true);

        setFundingType("credit_card");
      },
    },
    {
      icon: <BankIcon />,

      text: "Fund Wallet via Bank Transfer",

      subtitle: "Pay with your Bank Account",
      handler: () => {
        setFormModalOpenViaBankTransfer(true);
      },
    },
    {
      icon: <ArrowIcon />,
      text: "Fund Wallet via Bank Account",

      subtitle: "Pay with transfer from other bank",
      handler: () => {
        setFormModalOpenViaBankAccount(true);
      },
    },
    {
      icon: <PhoneIcon />,
      text: "Pay Attitude",
      subtitle: "Pay with your phone number",
      handler: () => {
        setFormModalOpenPayAttitude(true);
      },
    },
    {
      icon: <CallIcon />,
      text: "USSD",
      subtitle: "Pay with USSD code via your mobile device",
      handler: () => {
        setUssdmodalopen(true);
      },
    },
    {
      icon: <WalletListIcon />,
      text: "Wallet",

      subtitle: "Login or Scan to Pay",

      handler: () => {
        setPageNumber(3);
        // alert("Remove Wallet clicked");
      },
    },
  ];

  const PAGE_3_LIST = [
    {
      icon: <WalletListIcon />,
      text: "Scan to Pay",
      subtitle: "Make payment by scanning the QR code",
    },

    {
      icon: <WalletListIcon />,
      text: "Login To Pay",
      subtitle: "Login or Scan to Pay",
    },
  ];

  // Form Modal Fields list for Attitude

  const option_for_choose_wallet = cards?.map((card) => {
    return { name: card?.name, value: card?.id };
  });

  const option_for_choose_bank = banks?.map((bank) => {
    return { name: bank?.bank_name, value: bank?.id };
  });

  const Form_Modal_List_For_payattitude = [
    {
      formKey: "wallet",
      name: "wallet_id",
      label: "Choose Wallet",
      type: "select",
      options: option_for_choose_wallet,
    },

    {
      formKey: "fund_form",
      name: "phone_number",
      label: "Enter The Phone Number",
      icon: <Pay />,
    },
    {
      formKey: "fund_form",
      name: "amount",
      label: "N7, 000",
    },
  ];

  const Form_Modal_List_For_USSD = [
    {
      formKey: "wallet",
      name: "wallet_id",
      label: "Choose Wallet",
      type: "select",
      options: option_for_choose_wallet,
    },

    {
      formKey: "fund_form",
      name: "bank_name",
      label: "Select bank",
      type: "select",
      options: option_for_choose_bank,
    },
  ];
  const Form_Modal_List_For_BUTTONS_USSD_FIRST = [
    {
      text: "Back",
      name: "back",
      width: 90,
      handler: () => {},
      bgcolor: theme?.palette?.primary?.dark,
    },
    {
      text: "Next",
      name: "next",
      type: "submit",
      width: 150,
      handler: () => {},
    },
  ];
  const Form_Modal_List_For_USSD_Buttons_Second_Page = [
    {
      text: "Back",
      name: "back_button",
      type: "back",
      width: 90,
      handler: () => {
        alert("alert of back button");
      },
      bgcolor: theme?.palette?.primary?.dark,
    },
    {
      text: "Confirm",
      name: "confirm",
      type: "submit",
      width: 150,
      handler: () => {
        alert("alert of  Pay Now button");
      },
    },
  ];

  const Form_Modal_List_Via_Bank_Account = [
    {
      name: "waya_bank",
      label: "Waya Bank ",
      value: banks?.[0]?.bank_name,
      disable: true,
    },
    {
      name: "account_number",
      label: "Account Number - 35425684527",
      value: banks?.[0]?.account_number,
      icon: <CopyIcon />,
      disable: true,
    },
    {
      name: "account_name",
      value: banks?.[0]?.account_name,
      label: "Account Name - Melina Chizaram",
      disable: true,
    },
  ];
  const Form_Modal_List_For_payattitude_Buttons = [
    {
      text: "Back",
      name: "back_button",
      width: 90,
      type: "button",
      handler: () => {
        alert("1234");
      },
      bgcolor: theme?.palette?.primary?.dark,
    },
    {
      text: "Pay Now",
      name: "pay_now",
      type: "submit",
      width: 150,
      handler: () => {},
    },
  ];

  const Form_Modal_TextFields_Bank_transfer = [
    {
      formKey: "wallet",
      name: "wallet_id",
      label: "choose wallet",
      type: "select",
      options: option_for_choose_wallet,
    },
    {
      formKey: "fund_form",
      name: "bank_name",
      label: "Select bank",
      type: "select",
      options: option_for_choose_bank,
    },
    {
      formKey: "fund_form",
      name: "account_number",
      label: "Account Number",
    },
    {
      formKey: "fund_form",
      name: "amount",
      label: "Enter Amount",
    },
    {
      formKey: "fund_form",
      name: "transfer_remark",
      label: "Transaction Remark",
    },
  ];
  const Form_Modal_Second_Page_List_Bank_Transfer = [
    {
      name: "transaction_password",
      label: "Transaction Password",
      type: "password",
    },
  ];
  const Form_Modal_Second_Page_List_USSD = [
    {
      formKey: "fund_form",
      name: "phone_number",
      label: "Phone Number",
    },
    {
      formKey: "fund_form",
      name: "amount",
      label: "Amount",
    },
  ];

  const Form_Modal_List_For_Bank_Transfer_Buttons = [
    {
      text: "Back",
      name: "back",
      width: 90,
      handler: () => {},
      bgcolor: theme?.palette?.primary?.dark,
    },
    {
      text: "Next",
      name: "next",

      width: 150,
      handler: () => {},
    },
  ];
  const Form_Modal_List_For_Bank_Transfer_Buttons_Second_Page = [
    {
      text: "Back",
      name: "back_button",
      type: "back",
      width: 90,
      handler: () => {
        alert("alert of back button");
      },
      bgcolor: theme?.palette?.primary?.dark,
    },
    {
      text: "Confirm",
      name: "confirm",
      type: "submit",
      width: 150,
      handler: () => {
        alert("alert of  Pay Now button");
      },
    },
  ];

  const Success_Buttons_List_Pay_Attitude = [
    {
      name: "no",
      text: "No",
      handler: () => {
        alert("No Button Clicked ");
      },
    },
    {
      name: "yes_continue",
      text: "Yes  Continue",
      handler: () => {
        alert("Yes Continue Clicked ");
      },
    },
  ];

  //states

  const [modalOpen, setModalOpen] = useState(false);

  const [FormModalOpenPayAttitude, setFormModalOpenPayAttitude] =
    useState(false);
  const [FormModalOpenViaBankAccount, setFormModalOpenViaBankAccount] =
    useState(false);
  const [FormModalOpenViaBankTransfer, setFormModalOpenViaBankTransfer] =
    useState(false);

  const [fundWalletModal, setFundWalletModal] = useState(false);
  const [mainTypeForPage1, setMainTypeForPage1] = useState("");
  const [fundingType, setFundingType] = useState("");

  const [open, setOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");
  const [pageNumber, setPageNumber] = useState(1);
  const [modalNumber, setModalNumber] = useState(1);
  const [formModalOpen, setFormModalOpen] = useState(false);
  // modal states
  const [Ussdmodalopen, setUssdmodalopen] = useState(false);
  const [ViaBankAccountModalState, SetViaBankAccountModalState] =
    useState(false);
  const [LoaderIcon, setLoaderIcon] = useState(<ModalSpinner />);
  const [LoaderText, setLoaderText] = useState("Transaction Processing");
  const [resStatus, setResStatus] = useState("");
  const [dateOpen, setDateOpen] = useState(false);
  const [successModal, setSuccessModal] = useState(false);

  // user handle close

  const usersHandlerClose = () => {
    setModalNumber(1);
    setModalOpen(false);
  };
  const usersHandlerClose2 = () => {
    setModalNumber(1);
    setFundWalletModal(false);
  };
  const modalCloseforAll = () => {
    setUssdmodalopen(false);
    setFundWalletModal(false);
    SetViaBankAccountModalState(false);
    setFormModalOpen(false);
    SetViaBankAccountModalState(false);
    setFormModalOpenPayAttitude(false);
    setFormModalOpenViaBankAccount(false);
    setFormModalOpenViaBankTransfer(false);
    setFreezeModal(false);
    setOpenFreezeModal(false);
    setSuccessModal(false);
  };

  // create wallet

  const submitHandler = (values) => {
    const data = {
      wallet: {
        name: values?.name,
        category: values?.category,
        email: values?.email,
        phone_Number: values?.phone_Number,
        bvn: values?.bvn,
        is_default: values?.is_default,
      },
    };
    setOpen(true);

    headersPost(ApiUrls?.createWallet, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          // setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          // setAlertIcon("success");
          setModalOpen(false);
          setSuccessModal(true);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(MainRoutes?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };
  // handle close
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setAlertOpen(false);
  };

  // Fund Wallet API

  const submitHandlerFundWallet = (data) => {
    // console.log(data);
    setOpen(true);
    headersPost(ApiUrls?.FUND_WALLET, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setLoaderIcon(<SuccessIcon />);
          resourcevariable = res?.status;
          // setAlertOpen(true);
          setFundWalletModal(false);
          setUssdmodalopen(false);
          setFormModalOpenPayAttitude(false);
          setFormModalOpenViaBankAccount(false);
          setFormModalOpenViaBankTransfer(false);
          setSuccessModal(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          setResStatus(res?.status);
          setLoaderText("Wallet Funding");
          // modalCloseforAll();
          // setFundWalletModal(false);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(MainRoutes?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  const createCreditCardData = (values) => {
    const data = {
      wallet: {
        wallet_id: values?.wallet_id,
        funding_type: fundingType,
      },

      fund_form: {
        amount: values?.amount,
        main_type: mainTypeForPage1,
        action: values?.action,
        card_number: values?.card_number,
        name_on_card: values?.name_on_card,
        expiration: expirationDate,
        cvv: values?.cvv,
        password: values?.password,
      },
    };
    submitHandlerFundWallet(data);
  };

  const getBanksData = () => {
    // setOpen(true);
    headersGet(ApiUrls?.GET_BANK_DATA)
      .then((res) => {
        if (res?.status === 200 && res?.data?.success) {
          setBanks(res.data?.banks);
          setOpen(false);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(MainRoutes?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  useEffect(() => {
    getBanksData();
  }, [api]);

  const ChangeModalNumberMethod = (values) => {
    if (
      values?.choose_wallet !== "" &&
      values?.amount !== "" &&
      values?.name_on_card !== "" &&
      values?.card_number !== "" &&
      values?.cvv !== ""
    ) {
      setModalNumber(2);
    }
  };

  const delProduct = (pro) => {
    setProduct(pro);
  };

  const walletFreezeHandler = () => {
    const data = {
      wallet: {
        id: product?.id,
        is_archived: !product?.is_archived,
      },
    };
    setOpen(true);

    headersPost(ApiUrls?.FREEZE_WALLET, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setOpenFreezeModal(false);
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          setApi(!api);
        } else {
          setOpenFreezeModal(false);
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(MainRoutes?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  return (
    <>
      {pageNumber === 1 && (
        <Box>
          {Wallettasks.map((item, index) => {
            return (
              <Button
                onClick={item?.handler || null}
                sx={{
                  padding: 0,
                  borderRadius: "16px",
                  mb: 1,
                  mt: 1,
                  width: "100%",
                  lineHeight: "0.75",
                }}
              >
                <Paper
                  sx={{
                    display: "flex",
                    alignItem: "center",
                    margin: "5px",
                    height: "80px",
                    width: "100%",
                    elevation: "1rem",
                    borderRadius: "16px",
                    Blend: "Pass through",
                    Left: "320px",
                    Top: "446px",
                    padding: "10px",
                  }}
                  style={{ boxShadow: "none", margin: 0, width: "100%" }}
                >
                  <Box display={"flex"} alignItems={"center"}>
                    <Icon
                      sx={{
                        width: "50px",
                        height: "50px",
                      }}
                    >
                      {" "}
                      {item?.icon}{" "}
                    </Icon>
                    <Typography
                      sx={{
                        FontFamily: "Inter",
                        size: "20px",
                        color: "#666666",
                        textAlign: "center",
                        marginLeft: "16px",
                        marginBottom: "5px",
                      }}
                    >
                      {item?.text}
                    </Typography>
                  </Box>
                </Paper>
              </Button>
            );
          })}
        </Box>
      )}
      {pageNumber === 2 && PAGE_2_LIST && (
        <Box>
          <Box sx={{ width: "10%" }} mt={2}>
            <Button onClick={() => setPageNumber(1)}>
              <BackIcon />
            </Button>
          </Box>

          {PAGE_2_LIST.map((item, index) => {
            return (
              <Button
                onClick={item?.handler || null}
                sx={{
                  padding: 0,
                  borderRadius: "16px",
                  mb: 1,
                  mt: 1,
                  width: "100%",
                  lineHeight: "0.75",
                }}
              >
                <Paper
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",

                    height: "80px",

                    elevation: "1rem",
                    borderRadius: "16px",
                    padding: "5px",
                    paddingLeft: 4,
                    boxShadow: "none",
                    margin: 0,
                    width: "100%",
                  }}
                >
                  <Box>
                    <Icon
                      sx={{
                        width: "50px",
                        height: "50px",
                        mt: 2,
                      }}
                    >
                      {" "}
                      {item?.icon}{" "}
                    </Icon>
                  </Box>
                  <Box display="flex" flexDirection={"column"}>
                    <Box>
                      <Typography
                        variant={"body1"}
                        ml={2}
                        sx={{
                          FontFamily: "Inter",
                          fontWeight: "bold",
                          textAlign: "left",
                          color: "#333333",
                          // textAlign:"center"

                          // marginLeft: "16px",
                          // marginBottom: "5px",
                        }}
                      >
                        {item?.text}
                      </Typography>
                    </Box>

                    <Box>
                      <Typography
                        variant={"body2"}
                        ml={2}
                        sx={{
                          FontFamily: "Inter",
                          color: "#333333",

                          // marginLeft: "16px",
                          // marginBottom: "5px",
                        }}
                      >
                        {item?.subtitle}
                      </Typography>
                    </Box>
                  </Box>
                </Paper>
              </Button>
            );
          })}
        </Box>
      )}
      {pageNumber === 3 && (
        <Box>
          <Box sx={{ width: "10%" }} mt={2}>
            <Button onClick={() => setPageNumber(2)}>
              <BackIcon />
            </Button>
          </Box>
          {PAGE_3_LIST.map((item, index) => {
            return (
              
              <Button
                onClick={item?.handler || null}
                sx={{
                  padding: 0,
                  borderRadius: "16px",
                  mb: 1,
                  mt: 1,
                  width: "100%",
                  lineHeight: "0.75",
                }}
              >
                  
                <Paper
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    margin: "5px",
                    height: "80px",
                    width: "100%",
                    elevation: "1rem",
                    borderRadius: "16px",
                    // Blend: "Pass through",
                    // Left: "320px",
                    // Top: "446px",
                    padding: "5px",
                    paddingLeft: 4,
                  }}
                  style={{ boxShadow: "none", margin: 0, width: "100%" }}
                >
                  <Icon
                    sx={{
                      width: "50px",
                      height: "50px",
                      mt: 2,
                    }}
                  >
                    {" "}
                    {item?.icon}{" "}
                  </Icon>
                  <Box
                    display="flex"
                    flexDirection={"column"}
                    paddingLeft={"3rem"}
                    alignItems={"start"}
                  >
                    <Box>
                      <Typography
                        variant={"body1"}
                        sx={{
                          FontFamily: "Inter",
                          fontWeight: "bold",
                          color: "#333333",

                          // marginLeft: "16px",
                          // marginBottom: "5px",
                        }}
                      >
                        {item?.text}
                      </Typography>
                    </Box>

                    <Box>
                      <Typography
                        variant={"body2"}
                        sx={{
                          FontFamily: "Inter",
                          color: "#333333",

                          // marginLeft: "16px",
                          // marginBottom: "5px",
                        }}
                      >
                        {item?.subtitle}
                      </Typography>
                    </Box>
                  </Box>
                </Paper>
              </Button>
            );
          })}
        </Box>
      )}
      <Modal
        open={fundWalletModal}
        onClose={usersHandlerClose2}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Paper
          elevation={1}
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "white",
            width: { xs: "80%", md: "50%", lg: "30%" },
            minHeight: "85%",
            borderRadius: 1,
            borderTop: `5px solid  ${theme.palette.primary.main}`,
          }}
        >
          <Formik
            initialValues={initialValues1}
            validationSchema={ModalValidationViaCreditCard}
            onSubmit={createCreditCardData}
            isValidating={true}
            isSubmitting={true}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleSubmit,
              setFieldTouched,
            }) => (
              <Form onSubmit={handleSubmit}>
                <Box className={classes.flexSetting} mt={1}>
                  <LimospayTextIcon />
                </Box>

                <Typography className={classes.flexSetting}>
                  Fund Wallet Using Credit Card
                </Typography>
                <Typography
                  variant={"subtitle1"}
                  className={classes.flexSetting}
                >
                  Payment Details
                </Typography>
                {modalNumber === 1 && (
                  <Typography
                    variant={"subtitle2"}
                    className={classes.flexSetting}
                  >
                    Input your Card Details to process payment
                  </Typography>
                )}

                {modalNumber === 1 && (
                  <Box margin={"auto"} width={"70%"}>
                    <TextField
                      fullWidth
                      name="wallet_id"
                      variant="standard"
                      label="Choose Wallet"
                      value={values?.wallet_id}
                      onChange={handleChange}
                      select
                      SelectProps={{
                        displayEmpty: true,
                      }}
                      error={touched?.wallet_id && Boolean(errors?.wallet_id)}
                      helperText={touched?.wallet_id && errors?.wallet_id}
                    >
                      {option_for_choose_wallet?.map((option) => (
                        <MenuItem value={option?.value}>
                          {option?.name}
                        </MenuItem>
                      ))}
                    </TextField>
                    <TextField
                      fullWidth
                      name="amount"
                      // type={"number"}
                      variant="standard"
                      label="Amount"
                      value={values?.amount}
                      error={touched?.amount && Boolean(errors?.amount)}
                      helperText={touched?.amount && errors?.amount}
                      onChange={handleChange}
                    ></TextField>
                    <TextField
                      fullWidth
                      name="name_on_card"
                      variant="standard"
                      label="Name on the Card"
                      value={values?.name_on_card}
                      error={
                        touched?.name_on_card && Boolean(errors?.name_on_card)
                      }
                      helperText={touched?.name_on_card && errors?.name_on_card}
                      onChange={handleChange}
                    ></TextField>
                    <TextField
                      fullWidth
                      name="card_number"
                      variant="standard"
                      label="Card Number"
                      value={values?.card_number}
                      error={
                        touched?.card_number && Boolean(errors?.card_number)
                      }
                      helperText={touched?.card_number && errors?.card_number}
                      onChange={handleChange}
                    ></TextField>
                    <Box
                      mt={2}
                      display={"flex"}
                      flexDirection={"row"}
                      justifyContent={"space-around"}
                    >
                      {/* <TextField
                        name="expiration"
                        variant="standard"
                        label="Expiration"
                        value={values?.expiration}
                        // error={touched?.email && Boolean(errors?.email)}
                        // helperText={touched?.email && errors?.email}
                        onChange={handleChange}
                      ></TextField> */}

                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          clearable={true}
                          open={dateOpen}
                          onClose={() => setDateOpen(false)}
                          name="expiration"
                          label="Expiration"
                          views={["year", "month"]}
                          minDate={new Date()}
                          openTo="year"
                          value={expirationDate}
                          onChange={(e) => {
                            setExpirationDate(e);
                          }}
                          error={
                            touched?.expiration && Boolean(errors?.expiration)
                          }
                          helperText={touched?.expiration && errors?.expiration}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              onClick={() => setDateOpen(true)}
                            />
                          )}
                        />
                      </LocalizationProvider>

                      <TextField
                        name="cvv"
                        variant="standard"
                        label="Cvv"
                        sx={{
                          marginLeft: 1,
                        }}
                        value={values?.cvv}
                        error={touched?.cvv && Boolean(errors?.cvv)}
                        helperText={touched?.cvv && errors?.cvv}
                        onChange={handleChange}
                      ></TextField>
                    </Box>
                    <Box
                      display={"flex"}
                      flexDirection={"row"}
                      justifyContent={"space-around"}
                    >
                      <Button
                        onClick={() => usersHandlerClose2()}
                        component={"span"}
                        variant="contained"
                        // type="submit"
                        sx={{
                          marginTop: 1,
                          height: theme.spacing(5),
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        // onClick={() => setModalNumber(2)}
                        // onClick={() => {
                        //   ChangeModalNumberMethod(values);
                        // }}
                        // type="submit"
                        component={"span"}
                        variant="contained"
                        onClick={(e) => {
                          e.preventDefault();
                          let upcomingErrors = [];
                          let fieldsTouched = [];
                          [
                            "wallet_id",
                            "name_on_card",
                            "card_number",
                            // "expiration",
                            "amount",
                            "cvv",
                          ].forEach((fieldName, index, array) => {
                            setFieldTouched(fieldName, true, true).then(() => {
                              const field_touched = touched?.[fieldName];
                              const field_errors = errors?.[fieldName];
                              if (field_errors) {
                                upcomingErrors.push(field_errors);
                              }
                              if (field_touched) {
                                fieldsTouched.push(field_touched);
                              }
                              if (
                                !upcomingErrors.length &&
                                fieldsTouched.length === array.length
                              ) {
                                setModalNumber(modalNumber + 1);
                              }
                            });
                          });
                        }}
                        sx={{
                          marginTop: 1,
                          height: theme.spacing(5),
                        }}
                      >
                        Pay N7,000
                      </Button>
                    </Box>
                  </Box>
                )}
                {modalNumber === 2 && (
                  <Box margin={"auto"} width={"80%"}>
                    <Typography
                      variant={"subtitle2"}
                      className={classes.flexSetting}
                      mt={3}
                      sx={{
                        fontSize: "12px",
                      }}
                    >
                      Kindly Enter Your Transaction Password To Proceed
                    </Typography>
                    <TextField
                      fullWidth
                      name="password"
                      variant="standard"
                      type={"password"}
                      label="Transaction Password"
                      sx={{ marginTop: 3 }}
                      value={values?.password}
                      error={touched?.password && Boolean(errors?.password)}
                      helperText={touched?.password && errors?.password}
                      onChange={handleChange}
                    ></TextField>
                    <Box
                      display={"flex"}
                      flexDirection={"row"}
                      justifyContent={"space-around"}
                      mt={3}
                    >
                      <Button
                        onClick={() => setModalNumber(1)}
                        variant="contained"
                        // type="submit"
                        sx={{
                          marginTop: 1,
                          height: theme.spacing(5),
                          width: 100,
                        }}
                      >
                        Back
                      </Button>
                      <Button
                        variant="contained"
                        type="submit"
                        sx={{
                          marginTop: 1,
                          height: theme.spacing(5),
                        }}
                      >
                        Confirm Payment
                      </Button>
                    </Box>
                  </Box>
                )}
              </Form>
            )}
          </Formik>

          {modalNumber === 1 && (
            <Box display={"flex"} justifyContent={"flex-end"} mt={1} mr={4}>
              <Typography align="center">
                Add This Card{" "}
                <Switch
                  component={"span"}
                  sx={{
                    color: theme.palette.primary.main,
                  }}
                >
                  Register
                </Switch>
              </Typography>
            </Box>
          )}
        </Paper>
      </Modal>
      <Modal
        open={modalOpen}
        onClose={usersHandlerClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Paper
          elevation={1}
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "white",
            width: { xs: "80%", md: "50%", lg: "30%" },
            minHeight: "85%",
            borderRadius: 1,
            borderTop: `5px solid  ${theme.palette.primary.main}`,
          }}
        >
          <Formik
            initialValues={initialValues}
            validationSchema={createWalletValidation}
            onSubmit={submitHandler}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleSubmit,
              setFieldValue,
            }) => (
              <Form onSubmit={handleSubmit}>
                <Box className={classes.flexSetting} mt={1}>
                  <LimospayTextIcon />
                </Box>

                <Typography className={classes.flexSetting}>
                  Create Wallet
                </Typography>

                <Box margin={"auto"} width={"70%"}>
                  <TextField
                    fullWidth
                    name="name"
                    variant="standard"
                    label="Wallet Name"
                    value={values?.name}
                    error={touched?.name && Boolean(errors?.name)}
                    helperText={touched?.name && errors?.name}
                    onChange={handleChange}
                  ></TextField>
                  <TextField
                    fullWidth
                    name="category"
                    variant="standard"
                    label="Type of Wallet"
                    value={values?.category}
                    error={touched?.category && Boolean(errors?.category)}
                    helperText={touched?.category && errors?.category}
                    onChange={handleChange}
                  ></TextField>
                  <TextField
                    fullWidth
                    name="phone_Number"
                    variant="standard"
                    label="Phone Number"
                    value={values?.phone_Number}
                    error={
                      touched?.phone_Number && Boolean(errors?.phone_Number)
                    }
                    helperText={touched?.phone_Number && errors?.phone_Number}
                    onChange={handleChange}
                  ></TextField>
                  <TextField
                    fullWidth
                    name="email"
                    variant="standard"
                    label="Email Address"
                    value={values?.email}
                    error={touched?.email && Boolean(errors?.email)}
                    helperText={touched?.email && errors?.email}
                    onChange={handleChange}
                  ></TextField>
                  <TextField
                    fullWidth
                    name="bvn"
                    variant="standard"
                    label="BVN"
                    value={values?.bvn}
                    error={touched?.bvn && Boolean(errors?.bvn)}
                    helperText={touched?.bvn && errors?.bvn}
                    onChange={handleChange}
                  ></TextField>

                  <Button
                    variant="contained"
                    type="submit"
                    fullWidth
                    sx={{
                      marginTop: 1,
                      height: theme.spacing(5),
                    }}
                  >
                    Create Wallet
                  </Button>
                </Box>
                <Box className={classes.flexSetting} mt={3}>
                  <Typography align="center">
                    Make This Your Default Account{" "}
                    <Switch
                      // component={"span"}
                      name={"is_default"}
                      values={values?.is_default}
                      onChange={(event, checked) => {
                        setFieldValue("is_default", checked ? "true" : "false");
                      }}
                      sx={{
                        color: theme.palette.primary.main,
                      }}
                      // onChange={switchHandler}
                    >
                      Register
                    </Switch>
                  </Typography>
                </Box>
              </Form>
            )}
          </Formik>
        </Paper>
      </Modal>

      {/* Success Cards from Create Wallet */}
      <LoadCard open={open} />
      <SuccessCard
        title={"Wallet"}
        msg={alertMsg}
        open={successModal}
        onClose={modalCloseforAll}
      />
      <FormModal
        open={Ussdmodalopen}
        modalPages={2}
        onClose={modalCloseforAll}
        TextFieldArray={Form_Modal_List_For_USSD}
        TextFieldArraySecond={Form_Modal_Second_Page_List_USSD}
        MainHeading={"Pay by dialing USSD code on your mobile device"}
        SecondMainHeading={"Fund Wallet Via Pay Attitude"}
        SecondSimpleText={"Pay with your phone number"}
        ButtonsArray={Form_Modal_List_For_BUTTONS_USSD_FIRST}
        ButtonsArraySecond={Form_Modal_List_For_USSD_Buttons_Second_Page}
        initialFormData={{
          wallet: {
            // wallet_id: "values?.choose_wallet",
            funding_type: "ussd",
          },
          fund_form: { main_type: mainTypeForPage1 },
        }}
        ValidationSchemaModals={ModalValidationUSSD}
        onSubmit={submitHandlerFundWallet}
        options={option_for_choose_wallet}
      />

      <FormModal
        open={FormModalOpenPayAttitude}
        onClose={modalCloseforAll}
        MainHeading={"Fund Wallet Via Pay Attitude"}
        SubHeading={""}
        SimpleText={"Pay With Your Phone Number"}
        TextFieldArray={Form_Modal_List_For_payattitude}
        ButtonsArray={Form_Modal_List_For_payattitude_Buttons}
        ModalLoaderText={LoaderText}
        ModalFinalSuccessState={resourcevariable}
        ModalFinalSuccessIcon={LoaderIcon}
        ResourceStatus={resStatus}
        afterSuccessFirstMessage={
          "Your Wallet was funded successfully via Pay Attitude"
        }
        afterSuccessSecondMessage={"Create Another "}
        SuccessButtonsList={Success_Buttons_List_Pay_Attitude}
        ValidationSchemaModals={ModalValidationPayAttitude}
        onSubmit={submitHandlerFundWallet}
        initialFormData={{
          wallet: {
            funding_type: "pa",
          },
          fund_form: { main_type: mainTypeForPage1, action: "issue" },
        }}
      />

      <FormModal
        open={FormModalOpenViaBankAccount}
        onClose={modalCloseforAll}
        MainHeading={"Fund Wallet Using Bank Account"}
        SubHeading={""}
        SimpleText={
          "Copy the details below to send money to your waya account from the bank's app"
        }
        TextFieldArray={Form_Modal_List_Via_Bank_Account}
        BackIcon={BackIcon}
      />

      <FormModal
        open={FormModalOpenViaBankTransfer}
        onClose={modalCloseforAll}
        MainHeading={"Fund Wallet Via Bank Transfer"}
        SubHeading={""}
        modalPages={2}
        SimpleText={"Select the Bank you are transferring to proceed "}
        TextFieldArray={Form_Modal_TextFields_Bank_transfer}
        TextFieldArraySecond={Form_Modal_Second_Page_List_Bank_Transfer}
        ButtonsArray={Form_Modal_List_For_Bank_Transfer_Buttons}
        ButtonsArraySecond={
          Form_Modal_List_For_Bank_Transfer_Buttons_Second_Page
        }
        SecondMainHeading={"Enter Your 4-digit Password"}
        SecondSimpleText={"Kindly Enter Your Transaction Password to proceed"}
        ValidationSchemaModals={ModalValidationBqankTransfer}
        initialFormData={{
          wallet: {
            // wallet_id: defaultWallet?.id,
            funding_type: "bank_transfer",
          },
          fund_form: { main_type: mainTypeForPage1, action: "issue" },
        }}
        onSubmit={submitHandlerFundWallet}
      />
      {/* Freeze Wallet Modal */}

      <Modal
        open={freezeModal}
        onClose={modalCloseforAll}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Paper
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "white",
            width: { xs: "80%", md: "50%", lg: "30%" },
            padding: 1,
            minHeight: "85vh",
            maxHeight: "85vh",
            borderRadius: 1,
            borderTop: `5px solid  ${theme.palette.primary.main}`,
            overflowY: "auto",
          }}
        >
          <Box paddingX={"8%"} paddingY={"5%"}>
            <Box display={"flex"} alignItems={"center"}>
              <Icon
                sx={{
                  width: "50px",
                  height: "50px",
                }}
              >
                <FreezeWalletIcon />
              </Icon>
              <Typography
                sx={{
                  FontFamily: "Inter",
                  size: "20px",
                  color: "#666666",
                  textAlign: "center",
                  marginLeft: "16px",
                  marginBottom: "5px",
                }}
              >
                Freezed Wallets
              </Typography>
            </Box>
            <TableContainer className={classes.list} sx={{ maxHeight: "70vh" }}>
              <Table
                sx={{ minWidth: 320 }}
                aria-label="simple table"
                stickyHeader
              >
                <TableHead>
                  {" "}
                  <TableRow>
                    {headings?.map((h, index) => {
                      {
                        return (
                          <TableCell
                            sx={{ fontWeight: "bold" }}
                            key={`${index}-table-heading-${h}`}
                          >
                            {h}
                          </TableCell>
                        );
                      }
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {cards?.map((row, index) => (
                    <TableRow key={`${index}-row.name-${index + 2}`}>
                      <TableCell className={classes.tableBodyText}>
                        {row?.name}{" "}
                      </TableCell>
                      <TableCell className={classes.tableBodyText}>
                        {row?.balance}
                      </TableCell>
                      <TableCell className={classes.tableBodyText}>
                        <Button
                          variant="none"
                          onClick={() => {
                            delProduct(row);
                            setOpenFreezeModal(true);
                          }}
                          size="small"
                          sx={{
                            padding: theme.spacing(0),
                            minWidth: "20px",
                            maxWidth: "35px",
                            maxHeight: "20px",
                            borderRadius: 3,
                          }}
                        >
                          {row?.is_archived ? (
                            <ToggleBlueOn />
                          ) : (
                            <ToggleBlueOff />
                          )}
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Paper>
      </Modal>
      <DelModal
        header={"Status"}
        status={product?.is_archived}
        open={openFreezeModal}
        handleClose={modalCloseforAll}
        statusHandler={walletFreezeHandler}
      />
      {/* <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop> */}
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={alertIcon}>
          {alertMsg}
        </Alert>
      </Snackbar>
    </>
  );
};
export default CustomListItem;
